<template>
  <div class="activity">
    <navbar_staff />
    <div class="space"></div>
    <b-container class="bv-example-row">
      <!-- ====================================== AVARTAR ================================================= -->
      <div class="circle">
        <span class="circle__btn">
          <img
            class="circle_img"
            :src="require('@/assets/avatars/' + code + '.jpg')"
            alt=""
          />
          <!-- <img
                  class="circle_img"
                  :src="require(`../../assets/avatars/${code}.jpg`)"
                  alt=""
                /> -->
        </span>
        <span class="circle__back-1"></span>
        <span class="circle__back-2"></span>
      </div>
      <!-- ====================================== TABS MENU =============================================== -->

      <div class="segmented-control">
        <input
          type="radio"
          name="radio2"
          v-model="radio_btn"
          @change="onChange"
          value=""
          id="tab-1"
          checked
        />
        <label for="tab-1" class="segmented-control__1"> <p>การลา</p></label>
        <input
          type="radio"
          name="radio2"
          v-model="radio_btn"
          @change="onChange"
          value="กิจกรรม"
          id="tab-2"
        />
        <label for="tab-2" class="segmented-control__2">
          <p>กิจกรรม</p>
          <span class="icon-button__badge_myjob"> </span
        ></label>

        <input
          type="radio"
          name="radio2"
          v-model="radio_btn"
          @change="onChange"
          value="NewOrder"
          id="tab-3"
        />
        <label for="tab-3" class="segmented-control__3">
          <p>ประชุม</p>

          <span class="icon-button__badge_new_order"> </span
        ></label>

        <div class="segmented-control__color"></div>
      </div>
      <!-- ===================================== END TABS MENU ============================================ -->
      <!-- ======================================== Detail Tabs ============================================= -->
      <!-- ======================================== ลา =================================================== -->
      <div class="detail" v-if="radio_btn === ''">
        <button class="btn btn-info" @click="download()">Ptint</button>
        <div id="page">
          <div class="container p-5">
            <p class="headerpdf">แบบใบลาป่วย ลาคลอดบุตร ลากิจส่วนตัว</p>
            <p class="subheader pull-right">
              เขียนที่....................................................................
            </p>
            <br/>
             <br/>
             <br/>
            <p class="date">วันที่...............เดือน.............................. พ.ศ ..........................</p>
       
            <p class="titlepdf pull-left">เรื่อง...........................................................</p> 
            <br/>
            <br/>
            <br/>
            <p class="topdf pull-left">เรียน...........................................................</p>
           
           
           
           
            <table class="table is-bordered is-striped m-5">
              <tr>
                <td>วันจันทร์</td>
                <td>สีเหลือง</td>
              </tr>
              <tr>
                <td>วันอังคาร</td>
                <td>สีชมพู</td>
              </tr>
              <tr>
                <td>พุธ</td>
                <td>สีเขียว</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <!-- ======================================= End ลา =================================================-->
    </b-container>
  </div>
</template>

<script>
import navbar_staff from "../layouts/navbar_staff.vue";
import html2PDF from "jspdf-html2canvas";
// import jsPDF from 'jspdf';

export default {
  name: "activity",
  components: { navbar_staff },
  data() {
    return {
      code: "",
      radio_btn: "",
    };
  },
  mounted() {
    if (localStorage.getItem("auth") != null) {
      let c = JSON.parse(localStorage.getItem("auth"));
      this.code = c.std_code;
    }
    // eslint-disable-next-line no-unused-vars
    const playBtn = document.querySelector(".circle__btn");
    // console.log(playBtn);
    // eslint-disable-next-line no-unused-vars
    const wave1 = document.querySelector(".circle__back-1");
    // console.log(wave1);
    // eslint-disable-next-line no-unused-vars
    const wave2 = document.querySelector(".circle__back-2");
    // console.log(wave2);
  },
  methods: {
    onChange() {
      // console.log(this.radio_btn);
    },
    download() {
      // var pdf = new jsPDF;
      // pdf.text('สวัสดี',10,10);
      // pdf.save('info.pdf');
      let page = document.getElementById("page");
      html2PDF(page, {
        jsPDF: {
          orientation: "portrait", // landscape or portrait
          unit: "mm",
          format: "a4",
        },
        imageType: "image/jpeg",
        output: "ใบลา.pdf",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: thsarabun;
  src: url(../../assets/font/angsau.ttf);
}
#page {
  font-family: "thsarabun";
}
.headerpdf {
  font-size: 2rem;
}
.titlepdf{
  font-size: 1.8rem;
} 
.topdf{
  font-size: 1.8rem;
}
.subheader  {
  font-size: 1.8rem;
}
.date{
  font-size: 1.8rem;
  margin-left: 15rem !important;
}
.activity {
  background: var(--greyLight-1) no-repeat center center;
  background-size: cover;
  min-height: 100vh;
  position: absolute;
  width: 100%;
}
.space {
  height: 90px;
}

/*  CHIP new order */
.chip_job {
  grid-column: 2/3;
  grid-row: 3/4;
  justify-self: center;
  width: 15rem;
  height: 3rem;
  border-radius: 1rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.chip {
  grid-column: 2/3;
  grid-row: 3/4;
  justify-self: center;
  width: 15rem;
  height: 3rem;
  border-radius: 1rem;
  /*  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
      -0.2rem -0.2rem 0.5rem var(--white);*/
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.chip__icon {
  width: 3rem;
  height: 3rem;
  border-radius: 1rem;
  margin: 0 0 0 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  color: orangered;
}
.chip_job p {
  font-size: 1.3rem;
  margin-right: 6.4rem;
  margin-top: 1rem;
  color: var(--greyDark);
  font-weight: bold;
}
.chip p {
  font-size: 1.3rem;
  margin-right: 4rem;
  margin-top: 1rem;
  color: var(--greyDark);
  font-weight: bold;
}
.chip__close {
  width: 1.6rem;
  height: 1.6rem;
  margin: 0 0.5rem;
  display: flex;
  font-size: 1.6rem;
  color: var(--greyLight-3);
  cursor: pointer;
}
/*END */

/*  Avatar BUTTON  */
.circle_content {
  position: relative;
}
.circle_img {
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.circle_floting {
  position: absolute;
  /* width: 46px;
    height: 40px;
    
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 12px; */
  top: 5px;
  margin-left: 6rem;
  font-size: 14px;
}
.circle {
  grid-column: 2/3;
  grid-row: 4/6;
  width: 9rem;
  height: 100%;
  justify-self: center;
  border-radius: 1rem;
  display: grid;
  grid-template-rows: 1fr;
  justify-items: center;
  align-items: center;
  margin-left: -1.39rem;
}
.circle__btn {
  grid-row: 1/2;
  grid-column: 1/2;
  width: 9rem;
  height: 6rem;
  display: flex;
  margin: 0.6rem;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 3.2rem;
  color: var(--primary);
  z-index: 300;
  background: var(--greyLight-1);
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  cursor: pointer;
  position: relative;
}
.circle__btn.shadow {
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
}
.circle__btn .play {
  position: absolute;
  opacity: 0;
  transition: all 0.2s linear;
}
.circle__btn .play.visibility {
  opacity: 1;
}
.circle__btn .pause {
  position: absolute;
  transition: all 0.2s linear;
}
.circle__btn .pause.visibility {
  opacity: 0;
}
.circle__back-1,
.circle__back-2 {
  grid-row: 1/2;
  grid-column: 1/2;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  filter: blur(1px);
  z-index: 100;
}
.circle__back-1 {
  box-shadow: 0.4rem 0.4rem 0.8rem var(--greyLight-3),
    -0.4rem -0.4rem 0.8rem var(--white);
  background: linear-gradient(
    to bottom right,
    var(--greyLight-3) 0%,
    var(--white) 100%
  );
  -webkit-animation: waves 4s linear infinite;
  animation: waves 4s linear infinite;
}
.circle__back-1.paused {
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}
.circle__back-2 {
  box-shadow: 0.4rem 0.4rem 0.8rem var(--greyLight-3),
    -0.4rem -0.4rem 0.8rem var(--white);
  -webkit-animation: waves 4s linear 2s infinite;
  animation: waves 4s linear 2s infinite;
}
.circle__back-2.paused {
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}

@-webkit-keyframes waves {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes waves {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
/*END */

/* tebs content */
.tebs_content {
  position: relative;
}
.tebs_floting {
  position: absolute;
  top: 0rem;
  left: 0rem;
  font-size: 14px;
}
.segmented-control {
  grid-column: 3/4;
  grid-row: 1/2;
  width: 19.5rem;
  height: 3.4rem;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  position: relative;
  left: 9.6rem;
  top: -4rem;
}
.segmented-control input {
  display: none;
}
.segmented-control > input:checked + label {
  transition: all 0.5s ease;
  color: rgb(209, 95, 2);
}
.segmented-control__1,
.segmented-control__2,
.segmented-control__3 {
  width: 6.3rem;
  height: 3.6rem;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #ff5f2d;
  transition: all 0.5s ease;
  margin-top: 1.5rem;
}
.segmented-control__1:hover,
.segmented-control__2:hover,
.segmented-control__3:hover {
  color: rgb(209, 95, 2);
}
.segmented-control__color {
  position: absolute;
  height: 2.5rem;
  width: 6.6rem;
  margin-left: 0.3rem;
  border-radius: 0.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  pointer-events: none;
}

#tab-1:checked ~ .segmented-control__color {
  transform: translateX(0);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-2:checked ~ .segmented-control__color {
  transform: translateX(6rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-3:checked ~ .segmented-control__color {
  transform: translateX(12.2rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
/* end*/
</style>
